module.exports = __webpack_public_path__ + "static/media/Circularuppms2016-17-18.dc5743bd.pdf";